import { ky } from "./api-config";

async function getAccount(account_id) {
    return await ky.get(`api/profile/${account_id}`, { searchParams: { for_edit: 1 }}).json();
}

async function postProfileAvatar(file, filename) {
    const form_data = new FormData();
    form_data.append("userfile", file);
    form_data.append("userfilename", filename);
    return await ky.post(`api/profile_avatar/`, { body: form_data }).json();
}

async function getTopic() {
    return await ky.get(`api/topics/`).json();
}

//client
async function getClientsList(query) {
    return await ky.get(`api/clients_list${query}`).json();
}

async function getVisibleClients() {
    return await ky.get("api/clients/?visible=1").json();
}

async function saveClientMonitoring(data) {
    return await ky.post("api/client_monitor/", { json: { client_monitors: data }}).json();
}

async function searchCompanies(params) {
    params.action = "get_companies_autocomplete";
    return await ky.get("api/dispatcher/", { searchParams: params }).json();
}

// - BOOKMARKS
async function getBookmarks(searchParams) {
    return await ky.get(`api/bookmarks/`, { searchParams: searchParams }).json();
}

async function putBookmark(id, body) {
    return await ky.put(`api/bookmarks/${id}`, { json: body }).json();
}

async function postBookmark(body) {
    return await ky.post(`api/bookmarks/`, { json: body }).json();
}

async function deleteBookmark(id) {
    return await ky.delete(`api/bookmarks/${id}`).json();
}

async function getTaskAssignees({ account_id, client_id }) {
    return await ky
        .get(`api/taskassignees/`, {
            searchParams: {
                account_id,
                client_id
            }
        })
        .json();
}

function postTaskOrder({ sorted_task_ids_list, date }) {
    return ky.post("api/task_order", { json: { sorted_task_ids_list, date }}).json();
}

function getTaskOrders(searchParams) {
    return ky.get("api/task_order", { searchParams }).json();
}

async function getProduct(product_id) {
    return await ky.get(`api/products/${product_id}`).json();
}

async function postProduct(product_id, body) {
    return await ky.post(`api/products/${product_id}`, { json: body }).json();
}

async function postContract(id, body, force = 0) {
    return await ky.post(`api/contracts/${id}`, { searchParams: { force }, json: body }).json();
}

async function deleteContract(id) {
    return await ky.delete(`api/contracts/${id}`).json();
}

//DEMO
async function startDemo() {
    return await ky.post(`api/dispatcher/?action=start_demo`).json();
}

async function endDemo() {
    return await ky.post(`api/dispatcher/?action=delete_demo_account`).json();
}

//CLIENT SETTINGS BY FEATURE
function getClientSettings(client_id, feature_id) {
    return ky.get(`api/clients/${client_id}/client_settings/${feature_id}`).json();
}

function saveClientSettings(client_id, feature_id, data) {
    return ky.post(`api/clients/${client_id}/client_settings/${feature_id}`, { json: data }).json();
}

function deleteClientSettings(client_id, feature_id) {
    return ky.delete(`api/clients/${client_id}/client_settings/${feature_id}`).json();
}

function testClientSettings(client_id, feature_id, data) {
    return ky.post(`api/clients/${client_id}/test_client_settings/${feature_id}`, { json: data }).json();
}
/* deprecate
function runClientIntegration(client_id_list, feature_id, data) {
    return ky.post(`api/clients/run_client_integration/${feature_id}`, { json: { ...data, client_id_list: client_id_list }}).json();
}
 */

//ACTIVITY
function fetchActivities() {
    return ky.get("api/activity_log/").json();
}

function confirmEmail(hash, email, locale_code) {
    return ky.post("api/confirm_email", { searchParams: { h: hash, e: email, l: locale_code }}).json();
}

function joinPendingHashLogin({ n, e, ih }) {
    return ky.post("api/join_hash_login", { searchParams: { n, e, ih }}).json();
}

function fetchCalendarPeriod(payload) {
    return ky.get("api/calendar/period/", {
        searchParams: {
            date_from: payload.date_from,
            date_until: payload.date_until,
            account_id_list: payload.account_id_list ? payload.account_id_list.join(",") : "",
            person_id_list: payload.person_id_list ? payload.person_id_list.join(",") : "",
        }
    }).json();
}

//TOOLBAR SEARCH AUTOCOMPLETE
async function toolbarSearch(keyword) {
    keyword = keyword.replace('+', '%2B');
    // console.log('toolbarSearch: ', keyword)
    return await ky.get(`api/dispatcher/?action=get_clients_and_users_autocomplete&keyword=${keyword}`).json();
}

const profile_account = { get: getAccount };
const clients_list = { get: getClientsList };
const clients_visible = { get: getVisibleClients };
/*const client_notes = {
    get: getClientNotes,
    post: postClientNotes,
    put: putClientNote,
    delete: deleteClientNote,
    patch: patchClientNote
};*/
const companies = { search: searchCompanies };
//const client_attachment = { post: postClientAttachment, delete: deleteClientAttachment };
const task_assignees = { get: getTaskAssignees };
const task_order = { get: getTaskOrders, post: postTaskOrder };
// - BOOKMARKS
const bookmarks = { get: getBookmarks, put: putBookmark, post: postBookmark, delete: deleteBookmark };
// - MONITORING
const monitoring = { post: saveClientMonitoring };

// - PRODUCT
const product = {
    get: getProduct,
    post: postProduct,
    put: postProduct,
    patch: postProduct,
    //delete: deleteProduct
};
// - CONTRACT
const contract = {
    post: postContract,
    put: postContract,
    patch: postContract,
    delete: deleteContract };

// - TOPIC
const topic = { get: getTopic /*, post: postTopic, delete: deleteTopic*/ };
// - GOOGLE

const profile_avatar = {
    post: postProfileAvatar
};
// - DEMO
const demo = {
    start: startDemo,
    end: endDemo
};
const client_settings = {
    get: getClientSettings,
    post: saveClientSettings,
    delete: deleteClientSettings,
    test: testClientSettings,
    /* deprecate
    run: runClientIntegration
     */
};
const activity = {
    get: fetchActivities
};
const user = {
    join_login: joinPendingHashLogin,
    confirm: confirmEmail
};
const events = {
    get: fetchCalendarPeriod
};
const toolbar_search = {
    get: toolbarSearch
};

// EXPORT
export {
    topic,
    clients_list,
    clients_visible,
    task_assignees,
    task_order,
    monitoring,
    bookmarks,
    companies,
    product,
    contract,
    profile_avatar,
    demo,
    profile_account,
    client_settings,
    activity,
    user,
    events,
    toolbar_search
};
